export type ClientBuildMeta = {
  buildId: string | null
  commitHash: string | null
  builtAt: string | null
}

// Client packages typecheck without @types/node. Keep these property accesses
// direct so CRA can inline REACT_APP_* at build time.
declare const process: {
  env: {
    REACT_APP_BUILD_ID?: string
    REACT_APP_COMMIT_HASH?: string
    REACT_APP_BUILT_AT?: string
  }
}

function readBuildEnv(value: string | undefined): string | null {
  if (!value) return null
  if (value.startsWith("%") || value.startsWith("REPLACE_")) return null
  return value
}

export function getClientBuildMeta(): ClientBuildMeta {
  return {
    buildId: readBuildEnv(process.env.REACT_APP_BUILD_ID),
    commitHash: readBuildEnv(process.env.REACT_APP_COMMIT_HASH),
    builtAt: readBuildEnv(process.env.REACT_APP_BUILT_AT)
  }
}

export function getSentryReleaseName(buildId: string): string {
  return `pathwright-js@${buildId}`
}

// Apollo sends this as the apollographql-client-version header when set.
export function getApolloClientVersion(): string | undefined {
  return getClientBuildMeta().buildId ?? undefined
}
